/* Estirón Kids – scroll reveals, count-ups, word rotator. Skipped in the theme editor and for reduced motion. */
(function () {
  if (window.ekMotionInit) return;
  window.ekMotionInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;
  var root = document.documentElement;

  var SELECTORS = [
    '.ek .ek-eyebrow', '.ek .ek-title', '.ek .ek-lead', '.ek .ek-note', '.ek .ek-callout',
    '.ek-card', '.ek-list__item', '.ek-row', '.ek-tl__item', '.ek-cmp tbody tr', '.ek-review',
    '.ek-faq details', '.ek-final', '.ek-guar > *', '.ek-mt__media', '.ek-stat', '.ek-mt__cta',
    '.ek-hero__box > *', '.ek-bar__it'
  ].join(',');

  function prepare(scope) {
    var els = (scope || document).querySelectorAll(SELECTORS);
    els.forEach(function (el) {
      if (el.classList.contains('ek-rv')) return;
      el.classList.add('ek-rv');
      var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--ek-d', Math.min(sib, 6) * 90 + 'ms');
    });
    document.querySelectorAll('.ek-tl, .ek-cmp, .ek-title').forEach(function (el) { el.classList.add('ek-rv-host'); });
    return document.querySelectorAll('.ek-rv, .ek-rv-host');
  }

  function countUp(el) {
    if (el.dataset.done) return;
    el.dataset.done = '1';
    var to = parseFloat(el.dataset.count) || 0;
    var dur = 1400, t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(to * e);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function start() {
    if (reduce || design || !('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-count]').forEach(function (el) { el.textContent = el.dataset.count; });
      return;
    }
    root.classList.add('ek-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        en.target.querySelectorAll && en.target.querySelectorAll('[data-count]').forEach(countUp);
        if (en.target.dataset && en.target.dataset.count) countUp(en.target);
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    prepare().forEach(function (el) { io.observe(el); });
    document.querySelectorAll('.ek-stats').forEach(function (el) { io.observe(el); });
  }

  /* Rotating words in the hero: <span data-ek-rotate="sano|fuerte|feliz"> */
  function rotators() {
    document.querySelectorAll('[data-ek-rotate]').forEach(function (el) {
      var words = el.dataset.ekRotate.split('|').filter(Boolean);
      if (words.length < 2 || reduce) { el.textContent = words[0] || ''; return; }
      var i = 0;
      el.textContent = words[0];
      setInterval(function () {
        el.classList.add('is-out');
        setTimeout(function () {
          i = (i + 1) % words.length;
          el.textContent = words[i];
          el.classList.remove('is-out');
        }, 380);
      }, 2400);
    });
  }

  /* 3D tilt of the floating hero product following the mouse */
  function tilt() {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('[data-ek-tilt]').forEach(function (wrap) {
      var box = wrap.closest('.ek-hero') || wrap, card = wrap.querySelector('.ek-float3d'), layer = wrap.querySelector('.ek-float-layer');
      if (!card) return;
      box.addEventListener('mousemove', function (e) {
        var r = box.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--ry', (x * 22).toFixed(1) + 'deg');
        card.style.setProperty('--rx', (-y * 14).toFixed(1) + 'deg');
        if (layer) {
          layer.style.setProperty('--px', (-x * 36).toFixed(1) + 'px');
          layer.style.setProperty('--py', (-y * 24).toFixed(1) + 'px');
        }
      });
      box.addEventListener('mouseleave', function () {
        card.style.setProperty('--ry', '0deg');
        card.style.setProperty('--rx', '0deg');
        if (layer) { layer.style.setProperty('--px', '0px'); layer.style.setProperty('--py', '0px'); }
      });
    });
  }

  function init() { start(); rotators(); tilt(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
